import { Box, Tabs, Tab, Typography, IconButton } from '@mui/material';
import { styled } from '@mui/system';

export const GenericOrderInfoStyles = styled(Box)(({ theme }) => ({
    flexGrow: 1,
    bgcolor: "background.paper", display: "flex",
    height: `${theme.pageHeight}px`,
    overflow: "hidden",
}));

export const TabsStyles = {
    marginTop: 2,
    borderRight: 1,
    borderColor: "divider",
    width: 250,
    bgcolor: "background.paper",
    "& .MuiTab-root": {
        alignItems: "center",
        py: 5,
        px: 0,
        fontSize: "0.875rem",
        "&:hover": {
            bgcolor: "action.hover",
        },
    },
}

export const DocumentItemStyles =(selected) => (
    {cursor: "pointer",
        p: 2,
        mb: 1,
        mr:1,
        borderRadius: 1,
        backgroundColor:
            selected
                ? "action.selected"
                : "background.paper",
        "&:hover": {
            backgroundColor: "action.hover",
        },
    }
)

export const PreviewDocumentBoxStyles = {
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
}

export const SubSectionStyles =(width,pr,mr) => (
    {
        marginTop: 2,
        width: width,
        flex: 1,
        pr: pr || 1,
        ...(!mr ? {} : { borderRight: 1, borderColor: "divider", marginRight: mr }),
    }
)

export const SectionHeaderStyles=(noMb) =>( {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    mb:noMb?0:2,
    pt: 1,
    borderBottom: "2px solid",
    borderColor: "divider",
    width: "100%",
})
export const ValueStyles=(isEmpty)=>(
    {
        color: isEmpty ? "text.disabled" : "text.primary",
        fontWeight: isEmpty ? "normal" : 550,
        wordBreak: "break-word",
    }
)

export const LabelStyles = {
    fontWeight: 500, color: "text.secondary"
}